import { Pipe, PipeTransform } from '@angular/core';
import { sprintf } from 'sprintf-js';

@Pipe({
  name: 'sprintf'
})
export class SprintfPipe implements PipeTransform {
    transform(v: string, ...args) {
        return sprintf(v, ...args);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/pipes/sprintf.pipe.ts